import React, { useCallback } from 'react';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { ChoiceList } from 'modules/choice-list';
import { popover } from 'modules/popover';
import { isEmpty, castArray, get, isUndefined } from 'lodash';
import { GLOBAL_LABELS } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { singleSelectAndSearch as SingleSelectAndSearch } from 'modules/singleSelectAndSearch';
 *
 * // render
 * <SingleSelectAndSearch propName='propValue'/>
 */
export const singleSelectAndSearch = ( props ) => {

     // open popover options
     const openPopover = useCallback( ( element ) => {

        popover.open( {
            referenceElement: element,
            view: ChoiceList,
            tooltip: false,
            isDropdown: true,
            compact: true,
            props: {
                allowFilter: true,
                allowSearch: true,
                displaySelectAllOption: false,
                type: props.type,
                options: [],
                
                // placeholder: getLabel( props.placeholder ),
                selected: isEmpty( props.value ) ? [] : castArray( props.value ),
                onChange: props.onChange,
                handleQueryChange: props.handleQueryChange,
                name: get( props, 'name' ),

                // pagination related Props
                disablePagination: props.disablePagination,
                onPaginationCallBack: props.onPaginationCallBack,
                fetchingType: props.fetchingType,

                // isPaginationFetching: props.isFetching
                // choiceListClassName: 'ui-table__head__cell__filter__choice-list',
            }
        } );
    }, [ props.value ] );

    const className = classnames( 'ui-single-select-and-search', props.className );
    const classForBottomTitle = classnames( 'ui-single-select-and-search__bottom__value', props.classForBottomTitle );
    const classForBottomValue = classnames( 'ui-single-select-and-search__bottom__value', props.classForBottomValue );
    const { selectedOption } = props;

    return (
        <div className={ className } onClick={ ( event ) => {
                event.stopPropagation();
                event.preventDefault();
                openPopover( event.currentTarget );
            } }
            >

            {/* label text */}
            { props.isLabelVisible ? (
                <div className='ui-single-select-and-search__title'>{ getLabel( props.title ) }</div>
            ) : null }
            
            <div className='ui-single-select-and-search__bottom'>

                { ! isUndefined( selectedOption ) ? (

                    <div className={ classForBottomValue }>
                        { getLabel( get( selectedOption, 'title', selectedOption )  ) }
                    </div>

                ) : (

                    <div className={ classForBottomTitle }>
                        { ! props.showDefaultLabelSelect ? getLabel( GLOBAL_LABELS.DISPLAY_TEXT_ALL ) : getLabel( GLOBAL_LABELS.DISPLAY_TEXT_SELECT )  }
                    </div>

                ) }
                
                <div className='ui-single-select-and-search__bottom__icon'>
                    { isUndefined( selectedOption ) ? (
                        <Icon name={ 'downArrow' }  height={ 14 } width={ 14 } />
                    ) : (
                        <div onClick={ ( event ) => {
                            event.stopPropagation();
                            event.preventDefault();
                            props.clearSelection();
                        } }>
                            <Icon name={ 'close' }  height={ 12 } width={ 12 } />
                        </div>
                       
                    ) }
                </div>
            </div>
        </div>
    );
};

// set display name
singleSelectAndSearch.displayName = 'singleSelectAndSearch';

// set default props
singleSelectAndSearch.defaultProps = {};

// prop types
singleSelectAndSearch.propTypes = {};
